<template>
  <main class="app-container">
    <div class="head">
      <div  class="avatar">
        <img :src="model.avatar" />
      </div>
      <h3>{{model.nickname}}</h3>
    </div>

    <div class="nav">
      <md-field>
        <router-link to="enroll-history">
          <md-cell-item title="报名记录" addon="" arrow>
            <span class="iconfont icon-calendar" slot="left"></span>
          </md-cell-item>
        </router-link>
        <router-link to="/my-course-bundle">
          <md-cell-item title="我的课包" addon="" arrow>
            <span class="iconfont icon-qianbao" slot="left"></span>
          </md-cell-item>
        </router-link>
        <router-link to="/leader/course-plans/create">
        <md-cell-item title="课程计划" addon="" arrow>
          <span class="iconfont icon-jihua" slot="left"></span>
        </md-cell-item>
        </router-link>
        <router-link to="/leader/courses">
          <md-cell-item title="我的课程" addon="" arrow>
            <span class="iconfont icon-jilu" slot="left"></span>
          </md-cell-item>
        </router-link>
        <!--</router-link>-->
        <!--<md-cell-item title="使用帮助" @click="showPage('help')" addon="" arrow>-->
          <!--<span class="iconfont icon-bangzhuzhongxin" slot="left"></span>-->
        <!--</md-cell-item>-->
        <md-cell-item title="客服电话" arrow>
          <span class="iconfont icon-kefu" slot="left"></span>
          <a :href="'tel:'+model.hot_line" slot="right">{{model.hot_line}}</a>
        </md-cell-item>
        <md-cell-item title="关于我们" @click="showPage('about')" addon="" arrow>
          <span class="iconfont icon-icon-safe-bluefuben" slot="left"></span>
        </md-cell-item>
      </md-field>
    </div>

    <md-landscape v-model="showFullScreen" v-if="showFullScreen" full-screen>
      <page-content :page_key="pageKey" container="landscape"></page-content>
    </md-landscape>

    <tab-bar></tab-bar>
  </main>
</template>

<script>
import {Field, CellItem,Landscape} from 'mand-mobile'
import TabBar from "../components/TabBar"
import PageContent from "../components/PageContent.vue";

export default {
  name: "profile",
  components: {
      PageContent,
      [Field.name]: Field,
      [CellItem.name]: CellItem,
      [Landscape.name]: Landscape,
      TabBar,
  },
  data() {
      return {
          pageKey: '',
          showFullScreen:false,
          model: {
              avatar: 'https://tofino.oss-cn-chengdu.aliyuncs.com/no-image.png',
              nickname: '---',
              hot_line: '',
              is_leader: false,
          }
      }
  },
  methods: {
      showPage(key) {
          this.pageKey = key;
          this.showFullScreen = true;
      }
  },
    created() {
      this.$http.get('users/me').then(({data}) => this.model = data);
    },
};
</script>

<style lang="scss" scoped>
.head {
  text-align: center;
  padding: 100px 30px;
  background: #334257;
  color: #fff;

  .avatar {
    width: 140px;
    height: 140px;
    box-sizing: content-box;
    border-radius: 50%;
    background: #879fc0;
    overflow: hidden;
    padding: 6px;
    margin: 0 auto 20px;
    /*border: 6px solid #879fc0;*/

    img {
      width: 140px;
      height: 140px;
      border-radius: 50%;
    }
  }
  
  h3{
    font-weight:normal;
    font-size: 36px;
  }
}
.nav {
  .md-field {
    /*padding: 0;*/
    margin-top: 20px;
    padding-top:0;
    padding-bottom:0;
  }
  .holder{
    /*width: 30px;*/
  }
  .iconfont {
    font-size:32px;
    color: #111a34;
  }

  a {
    color: #858b9c;
    text-decoration: none;
  }
}
</style>